<template>
  <div v-if="userInfo" class="my-info-area">
    <ul>
      <li>
        <div class="c-form-field">
          <label class="c-input-label-group">
            <input
              type="text"
              title="사업자등록번호"
              :value="userInfo.stcd2"
              disabled
            />
            <span class="input-label">사업자등록번호</span>
            <button type="button" class="c-btn-icon btn-small-delete">
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
      </li>
      <li>
        <div class="c-form-field">
          <label class="c-input-label-group">
            <input
              type="text"
              disabled
              title="대표자성명"
              :value="userInfo.j1kfrepre"
            />
            <span class="input-label">대표자성명</span>
            <button type="button" class="c-btn-icon btn-small-delete">
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
      </li>
      <li>
        <div class="c-form-field">
          <label class="c-input-label-group">
            <input
              type="text"
              disabled
              title="휴대폰번호(대표번호)"
              :value="userInfo.telf2"
            />
            <span class="input-label">휴대폰번호(대표번호)</span>
            <button type="button" class="c-btn-icon btn-small-delete">
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
      </li>
      <li>
        <div class="c-form-field">
          <label class="c-input-label-group">
            <input
              type="text"
              disabled
              title="아이디"
              :value="userInfo.custCd"
            />
            <span class="input-label">아이디</span>
            <button type="button" class="c-btn-icon btn-small-delete">
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
      </li>
      <li>
        <div class="c-form-field">
          <!-- D: 비밀번호 인풋 type-password 추가 -->
          <!-- D: 유효성 실패시 is-danger 추가 -->
          <label
            class="c-input-label-group type-password"
            :class="{ 'is-danger': isPasswordNvl }"
          >
            <input
              v-if="passwordMaskingYn"
              type="password"
              required
              title="새로운 비밀번호"
              v-model="form.password"
              maxlength="15"
              @keyup="() => (passwordTouched = true)"
              @blur="() => (passwordTouched = true)"
            />
            <input
              v-if="!passwordMaskingYn"
              type="text"
              required
              title="새로운 비밀번호"
              v-model="form.password"
              maxlength="15"
              @keyup="() => (passwordTouched = true)"
              @blur="() => (passwordTouched = true)"
            />
            <span class="input-label">새로운 비밀번호</span>
            <span v-show="isPasswordInvalid" class="input-result">
              사용불가
            </span>
            <span v-show="isPasswordEmpty" class="input-helper">
              비밀번호를 입력해 주세요
            </span>
            <span class="input-helper"
              >띄어쓰기 없는 영문, 숫자, 특수문자 (!@#$%^*+=-) 포함 8~15자</span
            >
            <button
              type="button"
              class="c-btn-icon btn-eye"
              :class="{ 'is-active': !passwordMaskingYn }"
              @click.prevent="() => (passwordMaskingYn = !passwordMaskingYn)"
            >
              <i class="c-icon icon-eye"></i>
            </button>
            <button
              type="button"
              class="c-btn-icon btn-small-delete"
              @click.prevent="() => (form.password = '')"
            >
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
      </li>
      <li>
        <div class="c-form-field">
          <!-- D: 비밀번호 인풋 type-password 추가 -->
          <!-- D: 유효성 실패시 is-danger 추가 -->
          <label
            class="c-input-label-group type-password"
            :class="{ 'is-danger': isPasswordCfmNvl }"
          >
            <input
              v-if="passwordCfmMaskingYn"
              type="password"
              required
              title="비밀번호 확인"
              v-model="form.passwordCfm"
              maxlength="15"
              @keyup="() => (passwordCfmTouched = true)"
              @blur="() => (passwordCfmTouched = true)"
            />
            <input
              v-if="!passwordCfmMaskingYn"
              type="text"
              required
              title="비밀번호 확인"
              v-model="form.passwordCfm"
              maxlength="15"
              @keyup="() => (passwordCfmTouched = true)"
              @blur="() => (passwordCfmTouched = true)"
            />
            <span class="input-label">비밀번호 확인</span>
            <span v-show="isPasswordCfmNotMatched" class="input-result">
              불일치
            </span>
            <span v-show="isPasswordCfmEmpty" class="input-helper">
              비밀번호 확인을 입력해 주세요
            </span>
            <button
              type="button"
              class="c-btn-icon btn-eye"
              :class="{ 'is-active': !passwordCfmMaskingYn }"
              @click.prevent="
                () => (passwordCfmMaskingYn = !passwordCfmMaskingYn)
              "
            >
              <i class="c-icon icon-eye"></i>
            </button>
            <button
              type="button"
              class="c-btn-icon btn-small-delete"
              @click.prevent="() => (form.passwordCfm = '')"
            >
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
      </li>
      <li>
        <div class="c-form-field">
          <label class="c-input-label-group">
            <input
              type="text"
              disabled
              title="특약점명"
              :value="userInfo.zbpName"
            />
            <span class="input-label">특약점명</span>
            <button type="button" class="c-btn-icon btn-small-delete">
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
      </li>
      <li>
        <div class="c-form-field">
          <label class="c-input-label-group">
            <input
              type="text"
              :value="userAddresss"
              disabled
              title="특약점주소"
            />
            <span class="input-label">특약점주소</span>
            <button type="button" class="c-btn-icon btn-small-delete">
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
      </li>
      <li>
        <div class="c-form-field">
          <label class="c-input-label-group">
            <input
              type="text"
              :value="kunEmpZbezeis"
              disabled
              title="지점 및 영업소"
            />
            <span class="input-label">지점 및 영업소</span>
            <button type="button" class="c-btn-icon btn-small-delete">
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
      </li>
      <li>
        <div class="c-form-field">
          <label class="c-input-label-group">
            <input type="text" :value="kunEmpNames" disabled title="담당자" />
            <span class="input-label">담당자</span>
            <button type="button" class="c-btn-icon btn-small-delete">
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
      </li>
      <li>
        <div class="c-form-field">
          <label class="c-input-label-group">
            <input
              type="text"
              :value="userInfo.telf1"
              disabled
              title="특약점 전화번호(대표번호)"
            />
            <span class="input-label">특약점 전화번호(대표번호)</span>
            <button type="button" class="c-btn-icon btn-small-delete">
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
      </li>
      <li>
        <div class="c-form-field">
          <label class="c-input-label-group">
            <input
              type="text"
              :value="userInfo.smtpAddr"
              disabled
              title="이메일"
            />
            <span class="input-label">이메일</span>
            <button type="button" class="c-btn-icon btn-small-delete">
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
      </li>
    </ul>
    <!-- D: PC 전용 -->
    <div class="c-btn-area type-full only-pc">
      <button
        type="button"
        class="c-button type-secondary type-large"
        @click.prevent="cancel"
      >
        <span>취소</span>
      </button>
      <button
        type="button"
        class="c-button type-primary type-large"
        :disabled="
          !passwordTouched ||
          !passwordCfmTouched ||
          isPasswordNvl ||
          isPasswordCfmNvl
        "
        @click.prevent="submit"
      >
        <span>회원정보 수정하기</span>
      </button>
    </div>
    <!-- // D: PC 전용 -->
    <!-- D: MO 전용 -->
    <div class="c-btn-area type-full is-fixed only-mo" data-bottom-fixed>
      <button
        type="button"
        class="c-mo-button type-secondary type-medium"
        @click.prevent="cancel"
      >
        <span class="bold">취소</span>
      </button>
      <button
        type="button"
        class="c-mo-button type-primary type-medium"
        :disabled="
          !passwordTouched ||
          !passwordCfmTouched ||
          isPasswordNvl ||
          isPasswordCfmNvl
        "
        @click.prevent="submit"
      >
        <span class="bold">
          회원정보 수정<span class="only-pc">하기</span>
        </span>
      </button>
    </div>
    <!-- // D: MO 전용 -->
  </div>
</template>
<script setup>
import { computed, inject, onMounted, ref } from "vue";
import Utils from "@/js/utils";
import * as cmUtil from "@/utils/cmUtil";
import { api } from "@/plugins/api";

const url = inject("url_prefix");

const userInfo = ref(null);

const form = ref({
  password: "",
  passwordCfm: "",
});

const passwordTouched = ref(false);
const passwordCfmTouched = ref(false);

const passwordMaskingYn = ref(true);
const passwordCfmMaskingYn = ref(true);

onMounted(() => {
  loadAgencyUserInfo();
});

const isPasswordNvl = computed(() => {
  return isPasswordEmpty.value || isPasswordInvalid.value;
});

const isPasswordEmpty = computed(() => {
  return passwordTouched.value && Utils.isBlank(form.value.password);
});

const isPasswordInvalid = computed(() => {
  return passwordTouched.value && !Utils.isValidPassword(form.value.password);
});

const isPasswordCfmNvl = computed(() => {
  return isPasswordCfmEmpty.value || isPasswordCfmNotMatched.value;
});

const isPasswordCfmEmpty = computed(() => {
  return passwordCfmTouched.value && Utils.isBlank(form.value.passwordCfm);
});

const isPasswordCfmNotMatched = computed(() => {
  return (
    passwordTouched.value && form.value.password !== form.value.passwordCfm
  );
});

const userAddresss = computed(() => {
  if (!userInfo.value) return "";

  return `(${userInfo.value.pstlz}) ${userInfo.value.zcity} ${userInfo.value.zstreet}`;
});

const kunEmpZbezeis = computed(() => {
  if (!userInfo.value || userInfo.value.kunEmpList.length === 0) return "";

  return userInfo.value.kunEmpList
    .map((item) => item.zbezei)
    .reduce((acc, cur, idx) => {
      const delim = idx === userInfo.value.kunEmpList.length - 1 ? "" : ", ";
      return acc + cur + delim;
    }, "");
});

const kunEmpNames = computed(() => {
  if (!userInfo.value || userInfo.value.kunEmpList.length === 0) return "";

  return userInfo.value.kunEmpList
    .map((item) => item.zempName)
    .reduce((acc, cur, idx) => {
      const delim = idx === userInfo.value.kunEmpList.length - 1 ? "" : ", ";
      return acc + cur + delim;
    }, "");
});

const initForm = () => {
  form.value = {
    password: "",
    passwordCfm: "",
  };
};

const cancel = () => {
  initForm();
};

const loadAgencyUserInfo = async () => {
  const res = await api.get(`${url}/agency/user/my-info`);
  userInfo.value = res.data;
};

const submit = async () => {
  const payload = {
    password: form.value.password,
  };

  const res = await api.post(`${url}/agency/user/password/change`, payload);

  const { resultCode } = res;
  if (resultCode !== 200) {
    return;
  }

  cmUtil.alert("회원정보가 변경되었습니다.");
  initForm();
};
</script>
